import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { parseJWT } from "../../utils/jwtUtils";

export default function DepositPopup({ onClose }) {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const [deposit, setDeposit] = useState({
    phoneNumber: "",
    amount: "",
    tx_ref: "",
    userId: userInfo?.id,
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDeposit((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // API call to deposit endpoint
      await axios.post(
        "https://backend.40minchbingo.com/bingo-api/manuwalDeposit",
        deposit,
      );

      setMessage("✅ Deposit successful!");
      setDeposit({ phoneNumber: "", amount: "", tx_ref: "" });
      // Close the modal after 1.5s
      setTimeout(() => {
        setMessage("");
        if (onClose) onClose();
      }, 1500);
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 px-4">
      <motion.div
        className="w-full max-w-md bg-[#12385d] rounded-xl shadow-lg p-6 sm:p-8"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      >
        <h2 className="text-2xl sm:text-3xl font-semibold mb-4 text-center text-white font-serif">
          Deposit Now
        </h2>

        {message && (
          <div className="bg-green-600 text-white p-3 mb-4 rounded text-center text-sm sm:text-base">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Phone */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Phone
            </label>
            <input
              type="text"
              name="phoneNumber"
              value={deposit.phoneNumber}
              onChange={handleChange}
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
              required
            />
          </div>

          {/* Amount */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={deposit.amount}
              onChange={handleChange}
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
              required
            />
          </div>

          {/* Tx_Ref */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Tx_Ref
            </label>
            <input
              type="text"
              name="tx_ref"
              value={deposit.tx_ref}
              onChange={handleChange}
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
              required
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-between mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-700 hover:bg-gray-600 text-white px-5 py-2 sm:py-3 rounded-md text-sm sm:text-base transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`w-full sm:w-auto bg-gradient-to-r from-[#4e6d8c] to-[#6784a4] hover:opacity-90 text-white px-5 py-2 sm:py-3 rounded-md font-semibold text-sm sm:text-base transition ${
                loading ? "cursor-not-allowed opacity-50" : ""
              }`}
            >
              {loading ? "Depositing..." : "Deposit Now"}
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
